import React from 'react';
import { gql, useQuery } from '@apollo/client';
import ReactHtmlParser from 'react-html-parser'; 
import './About.css';

const ABOUT_QUERY = gql`query PackGroupsQuery {
    about{
      text
    } 
  }
`;

const About = () => {
    const { loading, error, data } = useQuery(ABOUT_QUERY)

    if(loading) return <h4>...loading</h4>
    if(error) return <h4>{error.message}</h4>

    return (
      <div id="about" className="small-12 large-12 ">
        <div className="panel">
          <div>
            <h4 className="modal-title">About Visceral Sounds</h4>
            { ReactHtmlParser (data.about.text) }
          </div>
        </div>
      </div>
    )
}

export default About
